import React from 'react';
import { Outlet } from 'react-router-dom';

export function Challenge(props) {
  return <Outlet />;
}
